const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

export interface ContactFormSubmission {
  naam: string;
  email: string;
  onderwerp: string;
  bericht: string;
  portalId: string;
}

export async function submitContactForm(data: ContactFormSubmission): Promise<void> {
  const response = await fetch(`${supabaseUrl}/functions/v1/contact-form`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Unknown error' }));
    throw new Error(error.message || 'Failed to submit contact form');
  }
}
